/**
* Map class / Google map handler
*/
class Map {

    /**
     * Constructor mthod
     *
     * @param {jQuery} jQuery library
     * @param {String} elemSelector css selector for map div
     * @return void
     */
    constructor( jQuery, elemSelector, mapConfig ) {

        this.$ = jQuery;
        this.$mapElem = this.$( elemSelector );
        this.$markers = this.$mapElem.find( '.js-map-marker' );
        this.mapDataFileUrl = this.$mapElem.data( 'map-data-url' );
        this.mapConfig = mapConfig;
        this.openMarker = null;
        this.layer = undefined;
    }

    /**
     * Setup map config object
     */
    setupMapConfig() {

        // setup zoom level, center and map type
        this.mapConfig['zoom'] = this.$( window ).width() < 1200 ? 10 : 11;
        this.mapConfig['center'] = new google.maps.LatLng( 64.125967, -21.817748 );
        this.mapConfig['mapTypeId'] = google.maps.MapTypeId.ROADMAP;
    }

    /**
     * Add markers to map and add additional markers styles
     *
     * @param {jQueryelem} $marker div which holds info about marker
     * @param {gMap} map instance of google map
     * @return void
     */
    addMarker( $marker, map ) {

        const latlng = new google.maps.LatLng( $marker.attr( 'data-lat' ), $marker.attr( 'data-lng' ) );

        const markerIcon = {
            url: $marker.attr( 'data-icon' ),
            // This marker is 20 pixels wide by 32 pixels high.
            size: new google.maps.Size( 37, 47 ),
            // The origin for this image is (0, 0).
            origin: new google.maps.Point( 0, 0 ),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point( 0, 44 )
        };

        // create marker
        const marker = new google.maps.Marker({
            position: latlng,
            map: map
            // icon: markerIcon
        });

        // add to array
        this.map.markers.push( marker );

        // if marker contains HTML, add it to an infoWindow
        if ( $marker.html() ) {
            // create info window
            const infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener( marker, 'click', () => {
                // if there is active info window - close it
                if ( this.openMarker ) this.openMarker.close();
                // show infowindow and store reference to it
                infowindow.open( map, marker );
                this.openMarker = infowindow;
            });

            /*
            * The google.maps.event.addListener() event waits for
            * the creation of the infowindow HTML structure 'domready'
            * and before the opening of the infowindow defined styles
            * are applied.
            */
            // google.maps.event.addListener( infowindow, 'domready', function () {

            //     // Reference to the DIV which receives the contents of the infowindow using jQuery
            //     const $iwOuter = jQuery('.gm-style-iw');
            //     // Moves the infowindow to the right.
            //     $iwOuter.parent().parent().css({ left: '145px' });

            //     /* The DIV we want to change is above the .gm-style-iw DIV.
            //     * So, we use jQuery and create a $iwBackground variable,
            //     * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
            //     */
            //     const $iwBackground = $iwOuter.prev();

            //     // Remove the background shadow DIV
            //     $iwBackground.children(':nth-child(2), :nth-child(4)').css({ 'display': 'none' });

            //     // Remove the white background DIV
            //     // $iwBackground.children(':nth-child(4)').css({'display' : 'none'});

            //     // Moves the shadow of the arrow 76px to the left margin
            //     $iwBackground.children(':nth-child(1)').css({ 'border-top': '0px !important' });

            //     // Moves the arrow 76px to the left margin
            //     $iwBackground.children(':nth-child(1), :nth-child(3)').attr('style', function (i, s) { return s + 'left: 77px !important; border-top: 0px !important' });
            //     $iwBackground.children(':nth-child(1), :nth-child(3)').css({ display: 'none' });
            //     // $iwBackground.children( ':nth-child(1), :nth-child(3)' ).addClass('klasa-jaka');

            //     // $iwBackground.children( ':nth-child(3)' ).find( 'div' ).children().css({ 'box-shadow': 'none' });

            //     // Close button
            //     const $iwCloseBtn = $iwOuter.next();
            //     const $iwCloseBtnPic = $iwCloseBtn.next();
            //     // remove default close button picture
            //     $iwCloseBtn.find( 'img' ).attr( 'src', '' );
            //     // we have to access close element via css because of pseudo elements
            //     $iwCloseBtn.addClass( 'gm-style-iw-close-btn' );
            //     // override styles that gm api add through js
            //     $iwCloseBtn.css({
            //         top: '28px',
            //         right: '62px',
            //         width: '23px',
            //         height: '23px'
            //     });

            //     $iwCloseBtnPic.css({
            //         top: '28px',
            //         right: '62px',
            //         width: '23px',
            //         height: '23px'
            //     });

            //     // first child of infowindow creates couple of pixels of padding
            //     // because it's display prop is set to inline-block
            //     $iwOuter.children( ':nth-child(1)' ).css( { 'display': 'block' } );

            //     $iwOuter.parent().addClass( 'gm-style-iw-parent' );

            // });

        }
    }

    /**
    * Setup map position based on markers position
    */
    setMapPosition() {

        // vars
        const bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        this.map.markers.forEach( marker => {

            const latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

            bounds.extend( latlng );

        });

        // only 1 marker?
        if ( this.map.markers.length == 1 ) {

            // set center of map
            this.map.setCenter( bounds.getCenter() );
        }

    }

    /**
     * Run map setup
     */
    setupMap() {

        // if there is no map found abort
        if ( this.$mapElem.length < 1 ) { return; }

        // setup map config object
        this.setupMapConfig();
        // get map instance
        this.map = new google.maps.Map( this.$mapElem[0], this.mapConfig );

        this.map.markers = [];

        // add markers to map
        this.$markers.each( ( i, marker ) => {

            this.addMarker( this.$( marker ), this.map );
        });

        // if there is KML data provided load and display it
        if ( this.mapDataFileUrl ) {
            this.layer = new google.maps.KmlLayer({
                url: this.mapDataFileUrl,
                map: this.map
            });
            
        } else {
            // if there is no KML data provided, setup map position based on markers position
            this.setMapPosition();
        }


    }

}

export default Map;
